import { Controller } from "@hotwired/stimulus"

// The registration wizard uses a single footer for both saving and navigation.
// When the current step hosts an editable form (#resource-form, loaded in the
// step's turbo-frame), the "Next" / "Save & exit" buttons submit that form with
// return_to pointed at the destination — so the step is saved before navigating,
// and validation errors keep the founder on the step. Steps that host no form
// (the people / documents lists, the review panel) just follow the link.
//
// This lets us hide the hosted form's own sticky action bar (see the
// `.pu-wizard .pu-sticky-footer` rule), removing the duplicate set of controls.
export default class extends Controller {
  go(event) {
    // The hosted form, not a form inside an open modal (parties, etc.).
    const form = [...document.querySelectorAll("#resource-form")]
      .find((f) => !f.closest("#remote_modal"))
    if (!form) return // no hosted form on this step — let the link navigate

    event.preventDefault()
    const returnTo = form.querySelector("input[name='return_to']")
    if (returnTo) returnTo.value = event.params.url
    const submit = form.querySelector(
      "button.submit_button, button[type=submit], input[type=submit]"
    )
    submit ? form.requestSubmit(submit) : form.requestSubmit()
  }
}
